import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    teamsData: {name: "", columns: [], data:[] },
    masterList: [],
    masterDataCache: {} // Cache for master data by table name
};

const masterDataSlice = createSlice({
    name: "masterData",
    initialState,
    reducers: {
        setCurrentMaster: (state, action) => {
            state.teamsData = {...state.teamsData, ...action.payload};
        },
        setMasterList: (state, action) => {
            state.masterList = action.payload;
        },
        upsertMaster: (state, action) => {
            const master = action.payload
            if (!master?.dataId) return
            const index = state.masterList.findIndex((item) => item?.dataId === master.dataId)
            if (index >= 0) {
                state.masterList[index] = { ...state.masterList[index], ...master }
            } else {
                state.masterList.push(master)
            }
        },
        setCachedMasterData: (state, action) => {
            const { tableName, data } = action.payload;
            state.masterDataCache[tableName] = data;
        },
        getCachedMasterData: (state, action) => {
            return state.masterDataCache[action.payload];
        }
    }
});

export const { setCurrentMaster, setMasterList, upsertMaster, setCachedMasterData } = masterDataSlice.actions;

export default masterDataSlice.reducer;